import React, { useEffect, useState, useMemo } from "react";
import {
    sendAPIRequest,
    generateOptionsFromData,
    displayNotification,
} from "../../../helpers";
import DataTable from "../../components/DataTable";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCurrentPage } from "../../../redux/generalSlice";
import Tooltip from "@mui/material/Tooltip";
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import { useTranslation } from "react-i18next";
import DataConfirmationModal from "components/modals/DataConfirmationModal";
import AddNewPartnerTechModal from "components/modals/AddNewPartnerTechModal";

const Index = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [showDataConfirmationModal, setshowDataConfirmationModal] = useState(false);
    const [openAddPartnertechModal, setOpenAddPartnertechModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);



    const [data, setData] = useState([]);
    const [partnerTechName, setPartnerTechName] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [updatedId, setUpdatedId] = useState(null);
    const id = searchParams.get('id');
    const country_id = searchParams.get('country_id');
    const initialFilters = {
        id: [],
        country_id: [],
    };

    const [filters, setFilters] = useState(
        {
            ...initialFilters,
            id: id ? id.split(',').map(v => parseInt(v)) : [],
            country_id: country_id ? country_id.split(',').map(v => parseInt(v)) : [],
        }
    );

    useEffect(() => {
        dispatch(setCurrentPage("Partner Tech"));
        loadData();
        loadCountries();
        loadPartnerTechNames();
    }, []);

    const navigationFunction = (key, value) => {
        let params = { ...filters };
        params[key] = value;
        setFilters({
            ...params,
        });
        params.id = params.id.join(",");
        params.country_id = params.country_id.join(",");
        params = new URLSearchParams(params).toString();
        let temp = params;
        temp = temp.replaceAll('&', '|');
        // setReturnParams(temp);
        navigate(`?${params}`);
    }

    const loadData = async (chk = true) => {
        try {
            setIsLoading(true);
            let fltr = { ...filters };
            if (chk == false) {
                fltr = initialFilters;
            }
            let params = new URLSearchParams();
            fltr.id.forEach((element) => {
                params.append("id", element);
            });
            fltr.country_id.forEach((element) => {
                params.append("country_id", element);
            });
            const req = await sendAPIRequest(`/api/partner-tech?${params}`);
            const res = await req.json();
            if (res.success) {
                setData([...res.data]);
                setIsLoading(false);
            } else {
                displayNotification('error', `${t("222", "Error loading data")} [B]`);
            }
        } catch (e) {
            console.log(e);
            displayNotification('error', `${t("222", "Error loading data")} [F]`);
        }
    };

    const resetFilter = async () => {
        setFilters({ ...initialFilters });
        navigate(``);
        loadData(false);
    }

    const loadCountries = async () => {
        try {
            const req = await sendAPIRequest(`/api/country`);
            const res = await req.json();
            if (res.success) {
                setCountries(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const loadPartnerTechNames = async () => {
        try {
            const req = await sendAPIRequest(`/api/partner-tech`);
            const res = await req.json();
            if (res.success) {
                setPartnerTechName(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const deleteRecord = async () => {
        try {
            const req = await sendAPIRequest(`/api/partner-tech/${deleteId}`, "DELETE");
            const res = await req.json();
            if (res.success) {
                await loadData();
                await loadPartnerTechNames();
                displayNotification("success", `Successfully deleted element`);

            } else {
                displayNotification("error", `Error deleting element data`, "[B]");

            }
        } catch (e) {
            console.log(e);
            displayNotification('error', 'Error deleting element data', "[F]");
        } finally {
            setshowDataConfirmationModal(false);
            setDeleteId(null);
        }
    };
    const handleDelete = (id) => {
        setDeleteId(id);
        setshowDataConfirmationModal(true);
    };

    const handleModalClose = async (result) => {
        setshowDataConfirmationModal(false);
        if (result) {
            await deleteRecord();
        }
        setDeleteId(null);
    };

    const reloadData = async (result) => {
        await loadData();
        await loadPartnerTechNames();
    };
    const handleOpenPartnerTechModal = (id) => {
        setOpenAddPartnertechModal(true);
        if (id) {
            setUpdatedId(id);
        }
    }
    const handleclosePartnerTechModal = () => {
        setOpenAddPartnertechModal(false);
        setUpdatedId(null);

    }
    const countryOptions = useMemo(() => {
        return generateOptionsFromData(countries, {
            value: "id",
            label: "country_complete_name",
        });
    }, [countries]);
    const partnerTechNameOptions = useMemo(() => {
        return generateOptionsFromData(partnerTechName, {
            value: "id",
            label: "partner_tech_name",
        });
    }, [partnerTechName]);
    return (
        <>
            <div className="container my-2">
                <div className="header card-woah border border-secondary d-flex px-4 py-2 my-2 shadow-sm w-100">
                    <div className='d-flex justify-content-between w-100'>
                        <div className="card-title1 lh-1">{t("-1", "Technical Partners Groups Management ")}</div>
                        <div className=''>
                            <button
                                className="btn btn--primary font-custom fs-6 ms-1"
                                onClick={() => handleOpenPartnerTechModal()}
                            >
                                {t("-1", "Add New")}
                                <i className="fas fa-plus align-middle ms-2  text-white" />
                            </button>
                            <Link
                                to='/portal'
                                className="float-end ms-1"
                            >
                                <button className="btn btn--primary btn-sm">
                                    <i className="fas fa-chevron-left align-middle mt-1 ms-2 text-white" />
                                    <span className="align-middle pe-1">{t("32", "Back")}</span>
                                </button>
                            </Link>
                        </div>

                    </div>
                </div>
                <div className="card card-woah border border-secondary shadow rounded-0 mb-1 ">
                    <div className="card-header px-4 py-2 min-h-10px">
                        <div className="card-title my-0">{t("14", "Filters")}</div>
                    </div>
                    <div className="card-body p-4">
                        <div className="row ">
                            <div className="col-md-6 col-12 mb-2">
                                <Tooltip
                                    title={t("667", "You can select multiple options")}
                                    placement="top"
                                    arrow
                                >
                                    <AutoCompleteDropdown
                                        error={false}
                                        required={false}
                                        label={t("-1", "Technical Partners Groups List")}
                                        multiple={true}
                                        hasselectall={true}
                                        options={partnerTechNameOptions}
                                        onChange={(event, value) => {
                                            if (value.some((v) => v.value == "Select all")) {
                                                if (filters.id.length == partnerTechNameOptions.length) {
                                                    // Deselect all options
                                                    navigationFunction("id", []);
                                                } else {
                                                    // Select all options
                                                    navigationFunction("id", partnerTechNameOptions.map((r) => r.value));
                                                }
                                            } else {
                                                navigationFunction("id", value.map((r) => r.value));
                                            }
                                        }}
                                        value={filters.id}
                                        size="medium"
                                    />
                                </Tooltip>
                            </div>
                            <div className="col-md-6 col-12 mb-2">
                                <Tooltip
                                    title={t("667", "You can select multiple options")}
                                    placement="top"
                                    arrow
                                >
                                    <AutoCompleteDropdown
                                        error={false}
                                        required={false}
                                        label={t("-1", "Countries")}
                                        multiple={true}
                                        hasselectall={true}
                                        options={countryOptions}
                                        onChange={(event, value) => {
                                            if (value.some((v) => v.value == "Select all")) {
                                                if (filters.country_id.length == countryOptions.length) {
                                                    // Deselect all options
                                                    navigationFunction("country_id", []);
                                                } else {
                                                    // Select all options
                                                    navigationFunction("country_id", countryOptions.map((r) => r.value));
                                                }
                                            } else {
                                                navigationFunction("country_id", value.map((r) => r.value));
                                            }
                                        }}
                                        size="medium"
                                        value={filters.country_id}
                                    />
                                </Tooltip>
                            </div>

                            <div className="col-md-12 col-sm-12 col-12 mt-2 text-end">
                                <button
                                    className="btn btn--outline fs-7 lh-1 mb-2 ms-2"
                                    type="button"
                                    onClick={() => resetFilter()}
                                >
                                    <span className="align-middle">{t("258", "Reset")}</span>
                                    <i className="fas fa-arrow-rotate-left text-black ms-2" />
                                </button>
                                <button
                                    className="btn btn--primary fs-7 lh-0 mb-2 ms-1"
                                    type="button"
                                    onClick={() => loadData()}
                                >
                                    <span className="align-middle">{t("21", "Search")}</span>
                                    <i className="fas fa-search text-white ms-2 " />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100">
                    <DataTable
                        getRowId={(row) => row.id}
                        isLoading={isLoading}
                        rows={data}
                        className="text-white bg-primary rounded-0"
                        columns={[
                            {
                                field: "partner_tech_name",
                                headerName: t("-1", "Technical Partners"),
                                headerClassName: "text-white bg-primary rounded-0",
                                minWidth: 150,
                                flex: 1,
                            },
                            {
                                field: "country",
                                headerName: t("-1", "Countries"),
                                headerClassName: "text-white bg-primary rounded-0",
                                flex: 1,
                                valueGetter: (params) =>
                                    params.row.relationPartnerTechAndCountry?.map(i => i.relationCountryAndPartnerTechMapping?.country_complete_name).join(","),
                            },
                            {
                                field: "actions",
                                type: "actions",
                                headerName: t("74", "Actions"),
                                headerClassName: "text-white bg-primary rounded-0",
                                getActions: (params) => [
                                    <GridActionsCellItem
                                        label={t("80", "Edit")}
                                        key={0}
                                        showInMenu
                                        onClick={() => handleOpenPartnerTechModal(params.row.id)}
                                    />,
                                    <GridActionsCellItem
                                        label={t("-1", "Delete")}
                                        key={0}
                                        showInMenu
                                        onClick={() =>
                                            handleDelete(params.row.id)
                                        }
                                    />,
                                ],
                                width: 90,
                            },
                        ]}
                    />
                </div>
            </div>
            <DataConfirmationModal
                show={showDataConfirmationModal}
                message={t("243", "Are you sure you want to delete?")}
                onClose={handleModalClose}
                btn1_text={"Ok"}
                btn2_text={"Cancel"}
            />
            {
                openAddPartnertechModal &&
                <AddNewPartnerTechModal
                    open={openAddPartnertechModal}
                    handleClose={handleclosePartnerTechModal}
                    id={updatedId}
                    reloadData={reloadData}
                />
            }

        </>
    );
}

export default Index;
